/* eslint-disable */

import $                      from "jquery";
import jQuery                 from 'jquery';
import moment                 from 'moment';
import {mapState, mapGetters} from 'vuex'


export default {

  data: function () {
    return {

      api_url: '',
      loading: false,
      show_winner: false,
      error: null,


      api_errors: {
        '0005': 'Lista Concorsi non trovata',
        '0013': 'Concorso non trovato',
        '0011': 'Errore nella giocata',
        '0010': 'JCatalog non trovato',
        '0012': 'Tentativi a disposizione terminati',
        '0008': 'Limite massimo di vincite raggiunto',
        '0009': 'Limite massimo di vincite giornaliere raggiunto',
        '0006': 'E\' necessario confermare la vincita precedente',
        '0007': 'Ordine non trovato'
      }


    }
  },

  methods: {

    dispatchUpdateBadges: function () {
      const badge_event = new Event('timparty_update_badges');
      window.dispatchEvent(badge_event);
    },

    dispatchRefreshToken: function () {
      const refresh_event = new Event('timparty_refresh_token');
      window.dispatchEvent(refresh_event);
    },

    dispatchMGMInitiative : function(){
      const mgm_initiative = new Event('timparty_refresh_mgm_initiative');
      window.dispatchEvent(mgm_initiative);
    },

    dispatchNotifications : function(){
      const notifications = new Event('timparty_refresh_notifications');
      window.dispatchEvent(notifications);
    },

    // GENERAL FUNCTIONS

    setApiUrl(api_url) {
      this.api_url = api_url;
    },

    callApi: function (data, callback) {

      var self = this;

      jQuery.post(this.api_url, data, function (response) {

        if (response.data != undefined) {
          if (response.data.errorCode != undefined && (response.data.errorCode == 401 || response.data.errorCode == "0004")) {
            self.dispatchRefreshToken();
          }
        }

        callback(response);
      });
    },

    callApiDelayed: function (data, minimum_time, callback) {

      if (!minimum_time) {
        minimum_time = 2000;
      } // 2s default

      var self = this;
      var start = new Date().getTime();

      jQuery.post(this.api_url, data, function (response) {

        if (response.data != undefined) {
          if (response.data.errorCode != undefined && (response.data.errorCode == 401 || response.data.errorCode == "0004")) {
            self.dispatchRefreshToken();
          }
        }

        var diff = (new Date().getTime()) - start;

        if (diff < minimum_time) {
          var delay = minimum_time - diff;
          setTimeout(function () {
            callback(response);
          }, delay);
        }
        else {
          callback(response);
        }

      }).then(function () {
        self.dispatchUpdateBadges();
      });
    },

    callApiGet: function (data, callback) {

      var self = this;

      var url    = this.api_url;
      var params = jQuery.param(data);
      if (params) {
        url = url + '?' + params;
      }


      jQuery.get(url, function (response) {

        if (response.data != undefined) {
          if (response.data.errorCode != undefined && (response.data.errorCode == 401 || response.data.errorCode == "0004"))
            // console.log('EC TOKEN EXPIRED');
          {
            self.dispatchRefreshToken();
          }
        }

        callback(response);
      });
    },

    alert: function (message) {
      alert(message);
    },

    padNumber: function (n, width, z) {
      z = z || '0';
      n = n + '';
      return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
    },

    checkEmail: function (email) {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },

    __: function (label) {
      return label;
    },

    getFileExtension(filename) {
      return filename.split('.').pop()
    },


    getRandomString(len) {

      if (!len) {
        len = 8;
      }

      return Math.random().toString(36).substr(2, len);
    },

    showError: function (error, details) {

      var title   = 'Attenzione';
      var content = 'Si è verificato un errore imprevisto';

      if (
        typeof error === 'object'
        && error !== null
      ) {
        if (error.errorCode != undefined && this.api_errors[error.errorCode] != undefined) {
          content = this.api_errors[error.errorCode];
        }
        else if (error.errorMessage != undefined) {
          content = error.errorMessage;
        }
        else {
          content = error;
        }
      }
      else {
        if (error && !details) {
          content = error;
        }
        else {
          title   = error;
          content = details;
        }
      }

      this.error = {
        title: title,
        content: content
      };
    },

    hideError: function () {
      this.error = null;
    },

    themePath: function (path) {
      return '/themes/custom/timparty/' + path.replace(/^\//, '');
    },

    modulePath: function (path) {
      return '/modules/custom/tim_party/' + path.replace(/^\//, '');
    },

    stripTags: function (html) {
      return html.replace(/(<([^>]+)>)/gi, "");
    },

    formatIsoDate: function (dt, include_time) {
      if (include_time) {
        return moment(dt).format('DD/MM/YYYY hh:mm')
      }
      else {
        return moment(dt).format('DD/MM/YYYY')
      }
    },

    formatTimestamp: function (ts, include_time) {
      if (include_time) {
        return moment(ts, 'X').format('DD/MM/YYYY hh:mm')
      }
      else {
        return moment(ts, 'X').format('DD/MM/YYYY')
      }
    },

    gtmEvent: function (event) {

      if (this.environment != 'dev') {
        console.log('GTM disabled: ', event);
      }

      window.dataLayer.push(event);

    },

    aaEvent: function (type, payload) {
      /*
      if(this.environment != 'dev'){
        console.log('GTM disabled: ', event);
      }
      */

      if (window.aaEvent != undefined) {
        window.aaEvent(type, payload);
      }
    },
    getCookie: function(name) {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) return parts.pop().split(';').shift();
    },
    updateDimensionHeaderWrapper: function (height) {
      $('.header-wrapper').height(height);
    },
    observeHeight: function () {
      this.updateDimensionHeaderWrapper(document.getElementById('header').clientHeight);
      let self = this;

      const resizeObserver = new ResizeObserver(() => {
        self.updateDimensionHeaderWrapper(document.getElementById('header').clientHeight);
      });

      resizeObserver.observe(document.getElementById('header'));
    },
    moveToAnchor: function(section) {
      if (window.document.getElementById(section) !== null) {
        window.document.getElementById(section).scrollIntoView(true);
        let moveY = window.document.getElementById(section).getAttribute('moveY') !== null ? window.document.getElementById(section).getAttribute('moveY') -100 : -100;
        window.scrollBy(0, moveY);
      }
    }
  },
  mounted() {
    let self = this;
    $(document).on('click', 'a[href^="#"]', function(event) {
      window.setTimeout(function() {
        let section = window.location.hash.substr(1);
        self.moveToAnchor(section);
      }, 0);
    });
    let section = window.location.hash.substr(1);
    window.setTimeout(this.offsetAnchor, 0);
    this.$nextTick(() => {
      this.observeHeight();
    })
    if (section) {
      this.$nextTick(() => {
        self.moveToAnchor(section);
      })
    }
  },

  computed: {
    ...mapState([
      'access_token',
      'access_token_created_at',
      'user',
      'user_loading',
      'access_token',
      'environment',
      'mgm_initiative',
      'notifications',
      'base_path_images'
    ]),
  },
}
